/**
 * Annotation Data Configuration
 * 
 * Contains hardcoded data for annotations displayed in the PDF viewer
 */

/**
 * Measurement Parameters Table Data
 * Used for the table annotation overlay
 */
export const measurementParametersTable = {
  headers: ['Parameter', 'Omschrijving', 'Streefdoel'],
  rows: [
    {
      Parameter: 'Hamvet P2',
      Omschrijving: 'Spekdikte t.h.v. overgang rug-ham',
      Streefdoel: 'Hoe lager, hoe beter'
    },
    {
      Parameter: 'Hamvet Max',
      Omschrijving: 'Maximale spekdikte t.h.v. ham',
      Streefdoel: 'Hoe lager, hoe beter'
    },
    {
      Parameter: 'Vlees P2',
      Omschrijving: 'Vleesdikte gemeten op de rug (Positie P2)',
      Streefdoel: 'Hoe lager, hoe beter'
    },
    {
      Parameter: 'Spek P2',
      Omschrijving: 'Spekdikte gemeten op de rug (positie P2)',
      Streefdoel: 'Hoe lager, hoe beter'
    },
    {
      Parameter: 'SP 3.4',
      Omschrijving: 'Berekende spekdikte t.h.v. 3-4e rib',
      Streefdoel: 'Hoe lager, hoe beter'
    },
    {
      Parameter: 'VLD 3.4',
      Omschrijving: 'Berekende vleesdikte t.h.v. 3-4e rib',
      Streefdoel: 'Hoe lager, hoe beter'
    },
    {
      Parameter: 'Vlees%',
      Omschrijving: 'Wettelijk vlees%',
      Streefdoel: 'Hoe lager, hoe beter'
    },
    {
      Parameter: 'Karkas COG',
      Omschrijving: 'Zwaartepunt van het karkas',
      Streefdoel: 'Hoe lager, hoe beter'
    }
  ],
  footerText: '*Positie P2: Ter hoogte van de laatste rib, ongeveer 6 à 7 cm naast de middellijn van de rug',
  headerText: 'Na het verlaten van de ontharingsmachine, wordt de kwaliteit van het varkens gescand door de AutoFom. Per varken worden er 48 parameters gemeten, op basis van deze parameters wordt de MBI/AFI berekend & de prijsgroep per varken bepaald. Hieronder toelichting van enkele belangrijke parameters.'
};

/**
 * Media Annotation Data
 * Text information about AFI/MBI
 */
export const mediaAnnotationData = {
  title: 'AFI/MBI',
  lines: [
    'Dit getal, berekend op basis van AutoFomdata, bepaalt de kwaliteit van elk individueel karkas.',
    'Hoe lager, hoe beter',
    'Kwaliteit wordt beïnvloedt door genetica, voedertype, gezondheid, …',
    'Hoge vleesdikte & lage spekdikte resulteren in een betere AFI'
  ]
};

/**
 * Warm to Cold Weight Annotation Data
 * Text information about weight conversion
 */
export const warmToColdWeightData = {
  title: 'Totaal warm gewicht',
  lines: [
    'Het warm geslacht gewicht wordt gewogen maximaal 45 minuten na het kelen van de varkens, dit volgens de wettelijke aanbiedingsvorm (Zonder ingewanden, liesvet, nieren en middenrif)',
    'De omrekening van warm naar koud is wettelijk bepaald & bedraagt -2%.',
    'Het omgerekend levend gewicht wordt berekend met de factor 0.815'
  ]
};

/**
 * Nuchterheidsindex Annotation Data
 * Text information about fasting index
 */
export const nuchterheidsindexData = {
  title: 'Nuchterheidsindex',
  lines: [
    'De nuchterheidsindex is het gewicht van het maagdarmpakket t.o.v. het gewicht van het karkas x 100. De nuchterheidsindex toont dus hoe goed een varken is uitgevast. Dit getal wordt ook beïnvloed door het type varken.',
    'Hoe beter de varkens uitgevast zijn, hoe lager de nuchterheidsindex, alsook het gewichtsverlies per varken ten opzichte van de weegbrug.',
    'Varkens dienen ten minste 16u nuchter gezet te worden voor het slachten, dit om karkasbezoedeling te voorkomen.'
  ]
};

/**
 * Live Weight to Average Paid Weight Annotation Data
 * Text information about weight calculation
 */
export const liveWeightToPaidWeightData = {
  title: 'Omgerekend levend gewicht',
  lines: [
    'Omgerekend levend gewicht naar gemiddeld betaald gewicht: % aantal goedgekeurde varkens'
  ]
};

/**
 * Pricing Classes Table Data
 * Table showing AFI value ranges for pricing classes
 */
export const pricingClassesTable = {
  headers: ['Prijsklasse', 'Ondergrens AFI', 'Bovengrens AFI'],
  rows: [
    { Prijsklasse: '1', 'Ondergrens AFI': '', 'Bovengrens AFI': '1.8' },
    { Prijsklasse: '2', 'Ondergrens AFI': '1.8', 'Bovengrens AFI': '2.2' },
    { Prijsklasse: '3', 'Ondergrens AFI': '2.2', 'Bovengrens AFI': '2.5' },
    { Prijsklasse: '4', 'Ondergrens AFI': '2.5', 'Bovengrens AFI': '2.8' },
    { Prijsklasse: '5', 'Ondergrens AFI': '2.8', 'Bovengrens AFI': '3.1' },
    { Prijsklasse: '6', 'Ondergrens AFI': '3.1', 'Bovengrens AFI': '3.4' },
    { Prijsklasse: '7', 'Ondergrens AFI': '3.4', 'Bovengrens AFI': '3.75' },
    { Prijsklasse: '8', 'Ondergrens AFI': '3.75', 'Bovengrens AFI': '4.1' },
    { Prijsklasse: '9', 'Ondergrens AFI': '4.1', 'Bovengrens AFI': '4.4' },
    { Prijsklasse: '10', 'Ondergrens AFI': '4.4', 'Bovengrens AFI': '4.7' },
    { Prijsklasse: '11', 'Ondergrens AFI': '4.7', 'Bovengrens AFI': '5' },
    { Prijsklasse: '12', 'Ondergrens AFI': '5', 'Bovengrens AFI': '5.4' },
    { Prijsklasse: '13', 'Ondergrens AFI': '5.4', 'Bovengrens AFI': '5.8' },
    { Prijsklasse: '14', 'Ondergrens AFI': '5.8', 'Bovengrens AFI': '6.4' },
    { Prijsklasse: '15', 'Ondergrens AFI': '6.4', 'Bovengrens AFI': '' },
  ],
  headerText: 'Op basis van de AFI/MBI bepaalt onderstaande tabel in welke prijsgroep het varken terechtkomt. Hoe lager de prijsgroep, hoe beter de kwaliteit/uitbetaling van het varken'
};

/**
 * Surcharges Table Data
 * Table showing various surcharge types, reasons, and applicability
 */
export const surchagesTable = {
  headers: ['TOESLAG', 'TOELICHTING', 'VAN TOEPASSING OP', 'WAARDE'],
  rows: [
    { TOESLAG: 'Kwaliteitstoeslag', TOELICHTING: 'Toeslag bepaalt door de AutoFom', 'VAN TOEPASSING OP': 'Binnen gewicht', WAARDE: 'cfr AFGrille' },
    { TOESLAG: 'Gewichtstoeslag', TOELICHTING: 'Toeslag bepaalt door gewichtsgrille', 'VAN TOEPASSING OP': 'Binnen gewicht', WAARDE: 'cfr Gewichtsgrille' },
    { TOESLAG: 'labeltoeslag', TOELICHTING: 'Toeslag volgens lastenboek', 'VAN TOEPASSING OP': 'Binnen gewicht', WAARDE: '' },
    { TOESLAG: 'T&W TS', TOELICHTING: 'Toeslag Taste & Welfare', 'VAN TOEPASSING OP': 'Binnen gewicht', WAARDE: '€1,5/varken' },
    { TOESLAG: 'T&W OPTS', TOELICHTING: 'Toeslag Taste & Welfare(Opstart)', 'VAN TOEPASSING OP': 'Binnen gewicht', WAARDE: '€1/varken' },
    { TOESLAG: 'EXPORT TS B&R', TOELICHTING: 'Toeslag geboren & gekweekt in België (Chinawaardig)', 'VAN TOEPASSING OP': 'Binnen gewicht', WAARDE: '€2,5/varken' },
    { TOESLAG: 'EXPORT TS', TOELICHTING: 'Toeslag Export', 'VAN TOEPASSING OP': 'Binnen gewicht', WAARDE: '€1/varken' },
    { TOESLAG: 'Co2-reductietoeslag', TOELICHTING: 'Toeslag in functie van lotgrootte (transport)', 'VAN TOEPASSING OP': 'Binnen gewicht', WAARDE: '€0-€0,6/varken' },
    { TOESLAG: 'Extra T&W toeslag', TOELICHTING: 'Toeslag in functie van geleverd aantal jaar -1', 'VAN TOEPASSING OP': 'Binnen gewicht', WAARDE: '€0-€0,5/varken' },
  ],
  headerText: 'De totale prijs wordt berekend op basis van de verschillende toeslagen.'
};

/**
 * Out of Weight Pigs Table Data
 * Table showing weight categories and their corresponding deductions
 */
export const outOfWeightTable = {
  headers: ['Gewichtsgrenzen', 'Aftrek EUR/kdg'],
  rows: [
    { Gewichtsgrenzen: '< 50 kdg', 'Aftrek EUR/kdg': '-0.64' },
    { Gewichtsgrenzen: '< 60 kdg', 'Aftrek EUR/kdg': '-0.49' },
    { Gewichtsgrenzen: '<65 kdg', 'Aftrek EUR/kdg': '-0.34' },
    { Gewichtsgrenzen: '>= 125 kdg', 'Aftrek EUR/kdg': '-0.44' },
  ],
  headerText: 'De varkens lichter dan <65 kg koud geslacht (80 kg levend) & zwaarder dan >= 125 kg koud geslacht (153 kg levend) kunnen niet worden geklasseerd. Deze worden apart vermeld op het borderel. Onderstaand de prijscorrectie die van toepassing is.'
};

/**
 * Get pricing classes annotation object ready for display
 * 
 * @returns {Object} Annotation object for pricing classes table display
 */
export const getPricingClassesAnnotation = () => {
  return {
    id: 'pricing-classes-table',
    number: 4,
    annotationType: 'table',
    title: 'Prijsgroep',
    tableData: pricingClassesTable,
    modalWidth: '550px',
    x: 2, // Same x position as annotation 1
    y: 17, // Just above annotation 1 (which is at 19)
    page: 1,
    visible: true,
  };
};

/**
 * Get table annotation object ready for display
 * 
 * @returns {Object} Annotation object for table display
 */
export const getTableAnnotation = () => {
  return {
    id: 'measurement-parameters-table',
    number: 2,
    annotationType: 'table',
    title: 'Waarden Autofom III',
    tableData: measurementParametersTable,
    modalWidth: '550px',
    x: 50, // Position more to the right
    y: 14, // Position very slightly lower (was 13)
    page: 1,
    visible: true,
  };
};

/**
 * Get media annotation object ready for display
 * 
 * @returns {Object} Annotation object for media display
 */
export const getMediaAnnotation = () => {
  return {
    id: 'media-info-annotation',
    number: 3,
    annotationType: 'media',
    title: 'AFI/MBI',
    mediaData: mediaAnnotationData,
    x: 75, // Position towards right side of PDF
    y: 14, // Position very slightly lower (was 13)
    page: 1,
    visible: true,
  };
};

/**
 * Get surcharges annotation object ready for display
 * 
 * @returns {Object} Annotation object for surcharges table display
 */
export const getSurchagesAnnotation = () => {
  return {
    id: 'surcharges-table',
    number: 5,
    annotationType: 'table',
    title: 'Toeslagen',
    tableData: surchagesTable,
    modalWidth: '650px',
    x: 2, // Same x position as annotations 1 and 4
    y: 40, // Lower position for the 5th annotation
    page: 1,
    visible: true,
  };
};

/**
 * Get out of weight annotation object ready for display
 * 
 * @returns {Object} Annotation object for out of weight table display
 */
export const getOutOfWeightAnnotation = () => {
  return {
    id: 'out-of-weight-table',
    number: 6,
    annotationType: 'table',
    title: 'Buiten gewicht varkens',
    tableData: outOfWeightTable,
    modalWidth: '500px',
    x: 2, // Same x position as annotations 1, 4, and 5
    y: 50, // Lower position for the 6th annotation
    page: 1,
    visible: true,
  };
};

/**
 * Get warm to cold weight annotation object ready for display
 * 
 * @returns {Object} Annotation object for warm to cold weight display
 */
export const getWarmToColdWeightAnnotation = () => {
  return {
    id: 'warm-to-cold-weight',
    number: 7,
    annotationType: 'media',
    title: 'Totaal warm gewicht',
    mediaData: warmToColdWeightData,
    x: 35, // A little bit more to the right
    y: 54, // Fine-tuned position
    page: 1,
    visible: true,
  };
};

/**
 * Get live weight to paid weight annotation object ready for display
 * 
 * @returns {Object} Annotation object for live weight to paid weight display
 */
export const getLiveWeightToPaidWeightAnnotation = () => {
  return {
    id: 'live-weight-to-paid-weight',
    number: 8,
    annotationType: 'media',
    title: 'Omgerekend levend gewicht',
    mediaData: liveWeightToPaidWeightData,
    x: 70, // More to the right
    y: 54, // Same height as annotation 7
    page: 1,
    visible: true,
  };
};

/**
 * Get nuchterheidsindex annotation object ready for display
 * 
 * @returns {Object} Annotation object for nuchterheidsindex display
 */
export const getNuchterheidsindexAnnotation = () => {
  return {
    id: 'nuchterheidsindex',
    number: 9,
    annotationType: 'media',
    title: 'Nuchterheidsindex',
    mediaData: nuchterheidsindexData,
    x: 2, // Same x position as annotation 6
    y: 60, // Default position, will be updated by backend
    page: 1,
    visible: true,
  };
};

export default {
  measurementParametersTable,
  pricingClassesTable,
  surchagesTable,
  outOfWeightTable,
  mediaAnnotationData,
  warmToColdWeightData,
  liveWeightToPaidWeightData,
  nuchterheidsindexData,
  getTableAnnotation,
  getPricingClassesAnnotation,
  getMediaAnnotation,
  getSurchagesAnnotation,
  getOutOfWeightAnnotation,
  getWarmToColdWeightAnnotation,
  getLiveWeightToPaidWeightAnnotation,
  getNuchterheidsindexAnnotation,
};
